import { CardList } from '@/components/ui';
import type { DetailRow } from '../types/workOrderDetail.types';
import { useParams, Link } from 'react-router-dom';

export function DetailChecklist({ checklists }: { checklists: DetailRow[] }) {
  const doneCount = checklists.filter((item) => item.is_done || item.completed).length;

  const { id } = useParams();

  return (
    <section className="space-y-2 rounded-md border border-slate-100 bg-white p-3">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-sm font-normal text-slate-950">Công việc con</h2>
        <div className="flex items-center gap-2">
          <span className="rounded-md bg-emerald-50 px-2 py-1 sm:text-sm text-xs text-emerald-600">{doneCount}/{checklists.length} hoàn thành</span>
          <Link to={`/work-orders/detail/${id}/sub-tasks`} className="rounded-md border border-slate-200 bg-white px-2 py-1 sm:text-sm text-xs text-emerald-700 hover:bg-slate-50 transition-colors">
            Quản lý chi tiết
          </Link>
        </div>
      </div>

      <CardList className="gap-2">
        {checklists.map((item, index) => {
          const done = Boolean(item.is_done || item.completed);
          return (
            <label key={item.id || index} className="flex items-start gap-2 rounded-md border border-slate-100 bg-slate-50 p-3 text-sm font-normal text-slate-700">
              <input type="checkbox" checked={done} readOnly className="mt-1 rounded-md border-slate-300 text-emerald-600 focus:ring-emerald-600" />
              <span className={done ? 'text-slate-400 line-through' : ''}>{item.title || item.name || item.content || `Công việc con ${index + 1}`}</span>
            </label>
          );
        })}
      </CardList>

      {checklists.length === 0 ? <p className="rounded-md bg-slate-50 p-3 text-sm font-normal text-slate-500">Chưa có công việc con.</p> : null}
    </section>
  );
}
